interface ProjectStatus {
  label: string;
  variant: string;
}

interface ProjectData {
  name: string;
  meta: string[];
  status: ProjectStatus;
}

interface ProgressData {
  label: string;
  value: number;
}

interface ProjectBannerProps {
  project: ProjectData;
  progress: ProgressData;
}

const ProjectBanner = ({ project, progress }: ProjectBannerProps) => {
  return (
    <div className="projectBanner">
      <div className="pbLeft">
        <h1>{project.name}</h1>
        <div className="pbMeta">
          {project.meta.map((item) => (
            <span className="pbMetaItem" key={item}>
              {item}
            </span>
          ))}
        </div>
      </div>
      <div className="pbRight">
        <span className={`badge ${project.status.variant}`}>
          <span className="badgeDot" />
          {project.status.label}
        </span>
        <div className="pbProgress">
          <span className="pbProgLabel">{progress.label}</span>
          <div className="pbProgTrack">
            <div
              className="pbProgFill"
              style={{ width: `${progress?.value ?? 0}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectBanner;
